import { client } from "@l2r-front/l2r-query"

import { useIncidentsQuery } from "../useIncidentsQuery"

import { eventsQueryKeys } from "./queryKeys"

function initialData(
    uuid,
    queryParameters,
) {
    const queries = client.getQueriesData({ queryKey: eventsQueryKeys["charts"](uuid) })
    for (const [_, queryData] of queries) {
        if (!queryData) {
            break
        }

        if (queryData[queryParameters.fields]) {
            return queryData
        }
    }
    return undefined
}

export function useEventChartQuery(
    uuid,
    queryParameters,
    config = {},
) {
    const url = `events/${uuid}/graphs/`

    return useIncidentsQuery(
        url,
        eventsQueryKeys["chart"](uuid, queryParameters.fields),
        queryParameters,
        config,
        () => initialData(uuid, queryParameters),
    )
}
